import { render, staticRenderFns } from "./GuardDashboard.vue?vue&type=template&id=aaf9ddee&scoped=true&"
import script from "./GuardDashboard.vue?vue&type=script&lang=js&"
export * from "./GuardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GuardDashboard.vue?vue&type=style&index=0&id=aaf9ddee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf9ddee",
  null
  
)

export default component.exports